import styles from "./blog.module.css"
import Link from "next/link";
import CollapsibleEvent from "../collapsibleEvent/collapsibleEvent";
import {useEffect, useState} from "react";
import RichText, {stripHtml} from "../richText/richText";

export default function Blog({id, date, image, thumb, title, subtitle, content, moreTitle, moreContent, shopProductId, shopProductText}){
    function showPopup() {
        let blog = document.getElementById(`blogPopup-${id}`);
            blog.classList.add(styles.show);
            
    }
    function hidePopup() {
        let blog = document.getElementById(`blogPopup-${id}`);
        blog.classList.remove(styles.show);
    }
    return(
        <>
            <div className={styles.container} onClick={() => showPopup()}>
                <h2>{date}</h2>
                <img alt={title || "Blog-Beitrag"} src={thumb} style={{width:"100%", height:"200px",objectFit:"cover"}}/>
                <h3 className="center-text" style={{marginBottom:0}}>{title}</h3>
                <p className="robertson size-30 brown" style={{margin:0}}>{subtitle}</p>
                {content && <p>{stripHtml(content, 100)}</p>}
                <div className="horizontal start left"><p style={{marginLeft:0}} className="annotation brown">Mehr</p> <p className="marker-after brown"></p> </div>
            </div>
            <div id={`blogPopup-${id}`} className={styles.overlay}>
                <div className={styles.popup}>
                    <p className="uppercase annotation" style={{cursor:"pointer"}} onClick={() => hidePopup()}>X Schliessen</p>
                    <div className={styles.box}>
                        <h2 style={{marginBottom:0}}>{title}</h2>
                        <p className="robertson size-30 brown" style={{marginTop:0}}>{subtitle}</p>
                    </div>
                    <RichText html={content}/>
                    <img alt={title || "Blog-Beitrag"} src={image} style={{width:"100%", height:"400px", objectFit:"cover"}}/>
                    <h3 className="center-text">{moreTitle}</h3>
                    <RichText html={moreContent}/>
                    {/* CTA at the very bottom of the popup so the recommendation
                        only appears after the full story is read. Plain black
                        underlined text — the earlier light-on-dark button got
                        lost between the image and the rich-text blocks. */}
                    {shopProductId != null && shopProductText && (
                        <Link href={`/weinkauf/shop/details/?id=${shopProductId}`}>
                            <p className="underline link uppercase center-text" style={{color: "#000", marginTop: "2rem"}}>
                                {shopProductText}
                            </p>
                        </Link>
                    )}
                    {/*<p className="button secondary">Teilen</p>*/}
                </div>
            </div>
        </>
    )
}